import { render, staticRenderFns } from "./user-detail.vue?vue&type=template&id=6a1f6280&scoped=true&"
import script from "./user-detail.vue?vue&type=script&lang=ts&"
export * from "./user-detail.vue?vue&type=script&lang=ts&"
import style0 from "./user-detail.vue?vue&type=style&index=0&id=6a1f6280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1f6280",
  null
  
)

export default component.exports